import AkRelationResolver from '../../../../spine-appkit-vue/src/components/wrappers/AkRelationResolver.js';

Vue.component('cms-media-relation-resolver', {
    functional: true,
    name: "CmsMediaRelationResolver",
    props: {
        relationString: {
            type: String,
            default: '',
            required: true
        },
        relationReference: {
            type: String,
            default: '',
            required: false
        },
        enableForeignList: {
            type: Boolean,
            default: false,
            required: false,
        },
        defaultIdsSelected: {
            type: Array,
            required: false,
            default: () => {return []}
        }
    },
    render(createElement, data) {
        let relation = data.props.relationString.split(':');

        let currentType = relation.shift();

        // Check if the next part of the relation string is the 'media-inspector'
        if (currentType === 'media-inspector') {
            const currentMediaId = relation.shift();
            const leftOverRelationString = relation.length ? relation.join(':') : undefined;

            return createElement("ak-stacked-window", {
                class: data.staticClass + ' ak-dark',
                props: {
                    showClose: false,
                },
                on: {
                    close: data.listeners.close,
                },
                scopedSlots: {
                    default: childProps => createElement('cms-media-inspector', {
                        props: {
                            mediaId: currentMediaId,
                            relationString: leftOverRelationString
                        },
                        on: {
                            close: childProps.close,
                        }
                    })
                }
            })
        } else {

            let currentBundle = relation.shift();
            let currentDefinition = relation.shift();

            // When we don't need to render the media inspector we use the default relation resolver flow
            return AkRelationResolver.resolve(relation, currentType, currentBundle, currentDefinition, createElement, data, 'cms-media-relation-data-table', true);
        }

    }
}, false);